import { BAR, FUNNEL, HORIZONTAL_STACKED, PIE } from '../../types';
import toBarEchartOption from './BarChart/toEchartOption';
import toPieEchartOption from './PieChart/toEchartOption';
import toHorizontalBarEchartOption from './StackedBarChart/toEchartOption';
import toFunnelEchartOption from './FunnelChart/toEchartOption';

/**
 * cada tipo de gráfico simples tem um conversar de data & theme
 * para option diferente.
 */
const strategies = {};
strategies[BAR] = (data, theme, mustReverse) => toBarEchartOption(data, theme, undefined, undefined, undefined, undefined, mustReverse);
strategies[PIE] = (data, theme) => toPieEchartOption(data, theme);
strategies[FUNNEL] = (data, theme) => toFunnelEchartOption(data, theme);
strategies[HORIZONTAL_STACKED] = (data, theme) => toHorizontalBarEchartOption(data, theme);

/**
 * recupera o echart option do gráfico simples baseado no tipo do gráfico,
 * nos dados e no tema.
 *
 * @param chartType tipo do gráfico. pode ser: 'pie' ou 'bar'
 * @param data resultados gerais
 * @param theme tema utilizado
 */
export default function getEchartOption(chartType, data, theme, mustReverse = false) {
  const toEchartOption = strategies[chartType];
  return chartType === BAR
    ? toEchartOption(data, theme, mustReverse)
    : toEchartOption(data, theme);
}
